import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useFiltersContext } from '../../../../packages/Filters/shared/utils/useFiltersContext';
import { resetTerms } from '../../../../packages/JsonQuery';
import { justChangeJsonQuery } from '../../../common/actions/filters/justChangeJsonQuery';
import { EmptyListing } from '../../../common/components/EmptyListing';
import { MAX_VISIBLE_FILTERS } from '../../../common/constants/activeFilters';
import { BASE_FILTERS_URL, SEO_URL_REGEXP } from '../../../common/constants/urls';
import { useActiveFilters } from '../../../common/hooks/useActiveFilters';
import { selectFiltersUrl } from '../../../common/selectors/urls';
import { IApplicationState } from '../../../common/types/redux';
import { getResettableFilters } from '../../../common/utils/getResettableFilters';

interface IEmptyListingContainerProps {
  onShow: () => void;
}

// Контейнер для EmptyListing с логикой активных фильтров
export const EmptyListingContainer = ({ onShow }: IEmptyListingContainerProps) => {
  const filtersUrl = useSelector<IApplicationState, string | null>(selectFiltersUrl);

  const dispatch = useDispatch();
  const { jsonQuery, onApply } = useFiltersContext();
  const { activeFilters, hasActiveFilters, hasExtraFilters } = useActiveFilters();

  const onShowAllFilters = React.useCallback(() => {
    const isSeoUrl = SEO_URL_REGEXP.test(window.location.pathname);
    const searchStringFromLocation = window.location.search;
    const safeFiltersUrlFromState = filtersUrl || BASE_FILTERS_URL;

    document.cookie = 'flavour=mobile;domain=.cian.ru;path=/';

    if (isSeoUrl) {
      window.location.href = safeFiltersUrlFromState;
    } else if (searchStringFromLocation) {
      window.location.href = `/nd/search/${searchStringFromLocation}`;
    } else {
      window.location.href = safeFiltersUrlFromState;
    }
  }, [filtersUrl]);

  const onResetAllFilters = React.useCallback(() => {
    // Получаем все фильтры, которые можно сбросить
    const resettableFilters = getResettableFilters(jsonQuery);

    if (resettableFilters.length > 0) {
      // Сбрасываем все фильтры кроме исключенных
      const nextJsonQuery = resetTerms(resettableFilters)(jsonQuery);
      dispatch(justChangeJsonQuery({ nextJsonQuery }));
      onApply();
    }
  }, [dispatch, jsonQuery, onApply]);

  return (
    <EmptyListing
      onShow={onShow}
      activeFilters={activeFilters}
      showEditFiltersButton={!hasActiveFilters}
      showAllFiltersButton={hasActiveFilters && (activeFilters.length > MAX_VISIBLE_FILTERS || hasExtraFilters)}
      showResetAllFiltersButton={activeFilters.length > 1}
      onShowAllFilters={onShowAllFilters}
      onResetAllFilters={onResetAllFilters}
    />
  );
};
